<div class="edit-wrapper">
  <!-- Page Header -->
  @if (!isLoaded()) {
    <div class="loading">
      <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych zestawu..." />
    </div>
  } @else {
    <div class="page-header">
      <div class="page-header-icon">
        <nz-icon nzType="edit" nzTheme="outline" />
      </div>
      <div>
        <h2 class="page-header-title">Edycja zestawu procedur</h2>
      </div>
    </div>

    <form nz-form nzLayout="vertical" class="edit-form">
      <!-- DANE ZESTAWU -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="file-text" nzTheme="outline" class="section-icon"></span>
          <span>Dane zestawu</span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="20">
            <nz-form-item>
              <nz-form-label nzRequired>Nazwa</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  editForm.name().invalid() &&
                  (editForm.name().touched() || submitted() || editForm.name().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input nz-input placeholder="Nazwa zestawu" [formField]="editForm.name" />
              </nz-form-control>
              <app-field-error
                [control]="editForm.name()"
                [submitted]="submitted()"
              ></app-field-error>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="4">
            <nz-form-item>
              <nz-form-label>Typ</nz-form-label>
              <nz-form-control>
                <input nz-input [value]="model().type" disabled />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24">
            <nz-form-item>
              <nz-collapse [nzExpandIconPosition]="'end'" [nzAccordion]="true">
                <nz-collapse-panel [nzHeader]="'Sugestie nazw zestawu procedur'" [nzActive]="false">
                  @if (isGeneratingSuggestions()) {
                    <nz-spin nzSimple nzSize="small" nzTip="Generowanie sugestii..." />
                  } @else if (showEmptyState()) {
                    <p>
                      Brak sugestii. Wygeneruj sugestie, aby zobaczyć propozycje nazw zestawu
                      procedur.
                    </p>
                  } @else {
                    @if (suggestions() && (suggestions()?.length ?? 0) > 0) {
                      <nz-list nzBordered>
                        @for (suggestion of suggestions(); track suggestion) {
                          <nz-list-item>
                            <ng-container>
                              <div nz-flex [nzJustify]="'flex-start'">
                                <span nz-typography>{{ suggestion.name }}</span>
                                @if (suggestion.best) {
                                  <nz-tag nzColor="blue" style="margin-left: 8px">Najlepsza</nz-tag>
                                }
                              </div>
                              <ul nz-list-item-actions>
                                <nz-list-item-action>
                                  <button
                                    nz-button
                                    nzType="link"
                                    (click)="setName(suggestion.name)"
                                    [nzSize]="'small'"
                                  >
                                    wybierz
                                  </button>
                                </nz-list-item-action>
                              </ul>
                            </ng-container>
                          </nz-list-item>
                        }
                      </nz-list>
                    }
                    @if (suggestionError()) {
                      <p class="error-message">{{ suggestionError() }}</p>
                    }
                  }
                  <nz-divider />
                  <div nz-flex [nzJustify]="'flex-end'">
                    <button
                      nz-button
                      nzType="primary"
                      (click)="generateSuggestions()"
                      [disabled]="isGeneratingSuggestions()"
                    >
                      @if (isGeneratingSuggestions()) {
                        <span nz-icon nzType="loading" nzSpin></span>
                      } @else {
                        <span nz-icon nzType="bulb"></span>
                      }
                      Generuj sugestie
                    </button>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Domyślny czas wykonania</nz-form-label>
              <nz-form-control>
                <nz-input-group nzAddOnAfter="min">
                  <input
                    nz-input
                    type="number"
                    placeholder="np. 20"
                    [formField]="editForm.defaultEtcInMinutes"
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24">
            <nz-list nzBordered nzHeader="Procedury w zestawie">
              @for (procedure of model().procedures; track procedure) {
                <nz-list-item>
                  <span nz-typography nzType="secondary">{{ procedure }}</span>
                </nz-list-item>
              }
            </nz-list>
          </div>
        </div>
      </nz-card>

      <!-- STATUS -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="safety-certificate" nzTheme="outline" class="section-icon"></span>
          <span>Status</span>
        </div>

        <nz-divider nzDashed style="margin: 12px 0"></nz-divider>

        <label nz-checkbox name="isHidden" [ngModel]="model().isHidden" [nzDisabled]="true">
          Ukryty
        </label>
      </nz-card>
    </form>

    <!-- FOOTER -->
    <div class="button-footer-wrapper">
      <a nz-button nzType="default" [routerLink]="['/procedure-sets']">
        <span nz-icon nzType="arrow-left"></span>
        Wstecz
      </a>

      <button
        nz-button
        nzType="primary"
        (click)="submit()"
        [nzLoading]="isSubmitting()"
        [disabled]="isSubmitting() || !model().name.trim()"
      >
        <span nz-icon nzType="save"></span>
        Zapisz zestaw
      </button>
    </div>
  }
</div>
